import React from 'react';
import {t} from '@lingui/core/macro';

import BlankLayout from 'shared/ui/BlankLayout/BlankLayout';
import NotFoundPage from 'shared/ui/ErrorPage/NotFoundPage';

import useHttpMonitorUnsubscribe from '../../../model/useHttpMonitorUnsubscribe';

import HttpMonitorUnsubscribe from './HttpMonitorUnsubscribe';

const HttpMonitorUnsubscribeScreen: React.FC = () => {
    const {domain, isLoading, isNotFound, unsubscribeHandler} = useHttpMonitorUnsubscribe();

    if (isNotFound) {
        return <NotFoundPage/>;
    }

    return (
        <BlankLayout pageTitle={t`Отписаться от мониторинга сайта`} isLoading={isLoading}>
            <HttpMonitorUnsubscribe unsubscribeHandler={unsubscribeHandler} domain={domain}/>
        </BlankLayout>
    );
};

export default HttpMonitorUnsubscribeScreen;
